var _defs, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.882,
    height: 113.833,
    viewBox: "0 0 91.882 113.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:none;stroke:#000;stroke-width:9px}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_356",
    "data-name": "Group 356",
    transform: "translate(-6602.167 13836)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_136",
    d: "M6620.333-13708h55.107s5.731 15.43 14.107 15.871v8.816h-82.882v-11.02s12.787-1.323 13.668-13.667z",
    className: "prefix__cls-1",
    "data-name": "Path 136",
    transform: "translate(0 -43.355)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rectangle_108",
    className: "prefix__cls-1",
    "data-name": "Rectangle 108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 0A35.5 35.5 0 0 1 71 35.5V57H0V35.5A35.5 35.5 0 0 1 35.5 0z",
    style: {
      stroke: "none"
    },
    transform: "translate(6612.774 -13819)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 4.5a31 31 0 0 1 31 31v14.486a2.514 2.514 0 0 1-2.514 2.514H7.014A2.514 2.514 0 0 1 4.5 49.986V35.5a31 31 0 0 1 31-31z",
    style: {
      fill: "none"
    },
    transform: "translate(6612.774 -13819)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_109",
    d: "M0 0H32V9H0z",
    "data-name": "Rectangle 109",
    transform: "translate(6632.774 -13836)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_110",
    d: "M0 0H11V6H0z",
    "data-name": "Rectangle 110",
    transform: "translate(6642.774 -13827)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_355",
    "data-name": "Group 355",
    transform: "translate(6633.339 -13758.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_111",
    d: "M0 0H11V5H0z",
    "data-name": "Rectangle 111",
    transform: "translate(19.435 -.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_112",
    d: "M0 0H10V5H0z",
    "data-name": "Rectangle 112",
    transform: "translate(.435 -.371)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedIcon);
export default __webpack_public_path__ + "static/media/confirmed-icon.fffe35f63935aa8ff3502babdffe8c2a.svg";
export { ForwardRef as ReactComponent };